import { render, staticRenderFns } from "./environmentalMonitoringList.vue?vue&type=template&id=b63d16fe&scoped=true"
import script from "./environmentalMonitoringList.vue?vue&type=script&lang=js"
export * from "./environmentalMonitoringList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63d16fe",
  null
  
)

export default component.exports